import { Link } from "react-scroll";
import liskovLogo from "../images/logos/liskov-logo-michael.png";

function Header() {
	const handleClick = (id) => {
		console.log(`HIT THE LINK ${id}`);
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: "smooth" });
		}
	};

	return (
		<div className="nav-bar">
			<div className="special-event-banner-desktop">
				Next Liskov info session: 18th May.&nbsp; 
				<a href="https://www.meetup.com/liskov-information-sessions/events/301014756/" target="_blank" rel="noopener noreferrer">
					Book here.</a> 
			</div>
			<div className="special-event-banner-mobile">
				Info session: 18/05.&nbsp; 
				<a href="https://www.meetup.com/liskov-information-sessions/events/301014756/" target="_blank" rel="noopener noreferrer">
					Book in.</a>
			</div>
			<div className="nav-heading">
				<Link to="home-town" spy={true} smooth={true}>
					<div id="home-heading">
						{/* <div className='liskov-nav-logo'>{"<li/>"}</div>  */}
						<img id="liskov-logo-heading" src={liskovLogo} alt="liskov logo" />
						<div className="liskov-nav-title">{"liskov_courses;"}</div>
					</div>
				</Link>
				<Link to="home-town" spy={true} smooth={true}>
					<div id="home-heading-mobile">
						{/* <div className='liskov-nav-logo'>{"<li/>"}</div> 
                    <div className='liskov-nav-title'>{"li_c;"}</div> */}
						<img id="liskov-logo-heading" src={liskovLogo} alt="liskov logo" />
					</div>
				</Link>
			</div>
			{/* <Link activeClass="active" to="home" spy={true} smooth={true}>Home</Link> */}
			<div className="nav-links">
				<div id="details-link" onClick={() => handleClick("details-section")}>
					<Link to="details-section" spy={true} smooth={true}>
						.details
					</Link>
				</div>
				<div id="contact-link" onClick={() => handleClick("contact-section")}>
					<Link to="contact-section" spy={true} smooth={true}>
						_contact;
					</Link>
				</div>
				<div id="longer-link" onClick={() => handleClick("who-section")}>
					<Link to="who-section" spy={true} smooth={true} offset={-40}>
						{"{..people}"}
					</Link>
				</div>
				{/* <div id="coding-link">
                    <Link to="coding-heading" spy={true} smooth={true}>
                        coding?
                    </Link>
                </div> */}
			</div>
			<div className="nav-mobile">
				<div id="m-details-link" onClick={() => handleClick("details-section")}>
					<Link to="details-section" spy={true} smooth={true} offset={-35}>
						{/* .d */}
						💻
					</Link>
				</div>
				<div id="m-longer-link" onClick={() => handleClick("contact-section")}>
					<Link to="contact-section" spy={true} smooth={true} offset={-35}>
						{/* {"{..l 📗📘 👾}"} */}
						☎️
					</Link>
				</div>
				<div id="m-coding-link" onClick={() => handleClick("who-section")}>
					<Link to="who-section" spy={true} smooth={true} offset={-20}>
						{/* code? 📞☎︎ */}
						🧑🏽
					</Link>
				</div>
				{/* <div id="m-contact-link">
                    <Link to="contact-us-heading" spy={true} smooth={true}> */}
				{/* _cntct; */}
				{/* ☎️
                    </Link>
                </div> */}
			</div>
		</div>
	);
}

export default Header;
